import Button from "components/v2/Button/Button";
import Checkbox from "components/v2/Checkbox/Checkbox";
import React, { useEffect, useMemo, useState } from "react";
import ExpandableSearch from "./ExpandableSearch";

type MultiSelectFilterProps = {
  options?: { label: string; value: string | number }[] | any;
  searchable?: boolean;
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  eventContext: string; // eslint-disable-line react/no-unused-prop-types
};
function MultiSelectFilter(props: MultiSelectFilterProps) {
  const { options, currentFilters, setFilters, filterKey, searchable } = props;
  const [searchText, setSearchText] = useState("");
  const [visibleCount, setVisibleCount] = useState(10);
  const [showAll, setShowAll] = useState(false);
  const filteredOptions = useMemo(() => {
    let filtered = options || [];
    if (searchText?.trim()?.length) {
      filtered =
        options?.filter((option: any) => option.label.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) || [];
    }
    const checkedOptions = filtered?.filter((option: any) => currentFilters[filterKey]?.includes(option.value));
    const uncheckedOptions = filtered?.filter((option: any) => !currentFilters[filterKey]?.includes(option.value));
    return [...checkedOptions, ...uncheckedOptions];
  }, [searchText, options, currentFilters, filterKey]);

  useEffect(() => {
    setVisibleCount(10);
    setShowAll(false);
  }, [options, currentFilters]);

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>, currentOption: any) => {
    if (e.target.checked) {
      setFilters({
        ...currentFilters,
        [filterKey]: Array.isArray(currentFilters[filterKey])
          ? [...currentFilters[filterKey], currentOption.value]
          : [currentOption.value],
      });
    } else {
      setFilters({
        ...currentFilters,
        [filterKey]: currentFilters[filterKey].filter((item: any) => item !== currentOption.value),
      });
    }
  };
  const handleToggle = () => {
    if (showAll) {
      setVisibleCount(10);
      setShowAll(false);
    } else {
      setVisibleCount(filteredOptions.length);
      setShowAll(true);
    }
  };
  return (
    <div className="multiselect-filter">
      {searchable && <ExpandableSearch value={searchText} onChange={(e) => setSearchText(e.target.value)} />}
      {filteredOptions?.slice(0, visibleCount).map((item, index) => (
        <div key={index} className="mb-md">
          <Checkbox
            size="sm"
            onChange={(e) => handleSelect(e, item)}
            label={item.label}
            checked={!!currentFilters[filterKey]?.includes(item.value)}
          />
        </div>
      ))}
      {filteredOptions.length > 10 && (
        <Button
          variant="link-color"
          onClick={handleToggle}
          label={showAll ? "Show less" : `Show all ${filteredOptions.length}`}
        />
      )}
    </div>
  );
}
export default MultiSelectFilter;
MultiSelectFilter.defaultProps = {
  options: [],
  searchable: false,
};
